export const rentalInstructions = `Please enter your own personal 'terms of \
service' for this rental. Instructions you may consider including: "When / \
how to pay, pick-up time, appropriate ways to use the item, proper storage /\
 travel techniques, etc."`;
